import styled from 'styled-components'
import { Button } from '~/shared/components/Button'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

export const ExpertsStyles = {
  Root: styled.div`
    width: 100%;
    height: calc(100dvh - var(--header-height));
    overflow: hidden;

    &:before {
      position: absolute;
      z-index: -1;
      inset: 0;
      content: '';
      background-color: ${COLORS.GRAY_100};
    }
  `,

  StyledContainer: styled(Container)`
    padding: 24px 16px;
  `,
  Title: styled.h1`
    font-weight: 700;
    font-size: 22px;
    line-height: 24px;
    color: ${COLORS.BLACK};
    margin-bottom: 16px;
  `,

  Subtitle: styled.h2`
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.BLACK};
    margin-bottom: 32px;
  `,

  University: styled.div`
    display: flex;
    padding: 12px;
    background: ${COLORS.WHITE};
    border: 1px solid ${COLORS.GRAY_30};
    border-radius: 12px;
    gap: 12px;
    align-items: center;

    &:not(:last-of-type) {
      margin-bottom: 12px;
    }
  `,

  UniversityLogo: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f3f1ff;
    border: 1px solid #d7d6fb;
    height: 40px;
    width: 40px;
    color: ${COLORS.PURPLE_400};
    font-weight: 700;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0.5px;
    border-radius: 12px;
  `,

  UniversityContent: styled.div`
    display: flex;
    flex-direction: column;
  `,

  UniversityDegree: styled.p`
    color: ${COLORS.GRAY_700};
    text-transform: uppercase;
    font-size: 8px;
    font-weight: 700;
    line-height: 12px;
  `,

  UniversityName: styled.p`
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.BLACK};
  `,

  StyledButton: styled(Button)`
    margin-top: auto;
  `,
} as const
